var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmtsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256.00001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.3833217,0,0,4.3833217,-465.02275,-231.4237)",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.228137
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129.20609 83.345863-10.91828 18.910627h21.83635z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.0234874
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.37336 82.671841 10.91807 18.910429 10.91788-18.910429z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.0234874
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.20246 82.671841 10.91808 18.910619 10.91807-18.910619z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.0234874
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.29143 62.413772-10.91787 18.909822h21.83555z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.0234874
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.12054 62.413571-10.91788 18.910023h21.83575z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.0234874
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.28781 61.73955 10.91828 18.910626 10.91807-18.910626z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.0234874
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.82795 82.627691-11.2143 19.628799h16.09908l5.66625-9.814498-5.66625-9.814301z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.0113786
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.79379 81.329949-8.18911-13.923071h11.65397l4.01918 6.961605-4.01918 6.961466z",
    style: {
      fillRule: "evenodd",
      opacity: 0.999,
      strokeWidth: 0.00807103
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmtsLogo);
export default __webpack_public_path__ + "static/media/cmts_logo.b203b5c981bd1806be4958a1a2551a27.svg";
export { ForwardRef as ReactComponent };